export default {"src":"/_next/static/media/FEEDBACK-ICON.ee9c692b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};